export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-movie-2-line text-background-50 text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                红桃影院
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              红桃影视为您汇聚电视剧全集免费资源，最新电视剧、热播剧集同步更新，
              国产剧全集、韩剧在线看一网打尽。高清画质，极速播放，让追剧成为享受。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-100 mb-4">快速导航</h4>
            <div className="space-y-2.5">
              <a href="#hero" className="block text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">首页</a>
              <a href="#cards" className="block text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">热播剧集</a>
              <a href="#ranking" className="block text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">热播榜单</a>
              <a href="#index" className="block text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">分类索引</a>
              <a href="#faq" className="block text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">常见问题</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-100 mb-4">热门分类</h4>
            <div className="space-y-2.5">
              <a href="#cards" className="block text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">古装大剧</a>
              <a href="#cards" className="block text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">悬疑烧脑</a>
              <a href="#cards" className="block text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">甜宠言情</a>
              <a href="#cards" className="block text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">韩剧在线看</a>
              <a href="#cards" className="block text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">国产剧全集</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-100 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-500 leading-relaxed">
              感谢各位合作伙伴的支持与信任。合作咨询请发送邮件至 business@hongtao.tv。
            </p>
          </div>
        </div>

        <div className="border-t border-background-800/50 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2019-2026 红桃影院 HongTao.tv 版权所有 | 高清电视剧在线观看 | 免费追剧平台
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-background-500 hover:text-background-300 transition-colors text-xs whitespace-nowrap">服务条款</a>
            <a href="#hero" className="text-background-500 hover:text-background-300 transition-colors text-xs whitespace-nowrap">隐私政策</a>
            <a href="#contact" className="text-background-500 hover:text-background-300 transition-colors text-xs whitespace-nowrap">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}